import { CommonModule } from "@angular/common";
import { Component, computed, inject } from "@angular/core";
import { Router } from "@angular/router";
import { resolveNotificationUrl } from "@models/enums/notification-event-type.enum";
import { Notification } from "@models/notification";
import { BadgeModule } from "primeng/badge";
import { PopoverModule } from "primeng/popover";
import { NotificationService } from "../../../../app/services/notification.service";
import { NotificationStore } from "../../../../app/services/notification.store";
import { NotificationItemComponent } from "../../../../app/shared/components/notification-item/notification-item.component";
import { ButtonComponent } from "../../button/button.component";

const PREVIEW_SIZE = 5;

@Component({
  selector: "app-navbar-notifications",
  imports: [
    CommonModule,
    ButtonComponent,
    PopoverModule,
    BadgeModule,
    NotificationItemComponent,
  ],
  templateUrl: "./navbar-notifications.component.html",
  styleUrl: "./navbar-notifications.component.scss",
})
export class NavbarNotificationsComponent {
  private readonly notificationService = inject(NotificationService);
  private readonly router = inject(Router);
  protected readonly store = inject(NotificationStore);

  protected readonly preview = computed(() =>
    this.store.notifications().slice(0, PREVIEW_SIZE),
  );
  protected readonly badgeValue = computed(() =>
    String(this.store.unreadCount()),
  );

  openPanel(event: Event, panel: { toggle: (e: Event) => void }): void {
    panel.toggle(event);
    if (this.store.notifications().length === 0 && !this.store.loading()) {
      this.loadPreview();
    }
  }

  handleRead(notification: Notification): void {
    this.store.markReadLocally(notification.id);
    this.notificationService.markRead(notification.id).subscribe();
  }

  handleOpenAction(
    notification: Notification,
    panel: { hide: () => void },
  ): void {
    panel.hide();
    const url = resolveNotificationUrl(notification);
    if (url) {
      this.router.navigateByUrl(url);
    }
  }

  markAllRead(): void {
    if (this.store.unreadCount() === 0) {
      return;
    }
    this.notificationService.markAllRead().subscribe(() => {
      this.store.zeroUnread();
    });
  }

  goToAll(panel: { hide: () => void }): void {
    panel.hide();
    this.router.navigateByUrl("/notifications");
  }

  private loadPreview(): void {
    this.store.setLoading(true);
    this.notificationService
      .list(1, PREVIEW_SIZE, false)
      .subscribe((result) => this.store.setFromList(result));
  }
}
